import React, { useEffect } from "react";

//components
import { DateRange, DateRangePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

//constants
import { IDoubleDateModalProps } from "./module/constants";
import messages from "./module/messages";

//utils
import enLocale from "date-fns/locale/en-GB";

//styles
import classes from "./DoubleDateModal.module.scss";

const DoubleDateModal = (props: IDoubleDateModalProps) => {
  const { show, onCloseModal, onConfirm, disablePastEndDate } = props;

  const [value, setValue] = React.useState<DateRange<Date>>([null, null]);
  const [nullEndDate, setNullEndDate] = React.useState<boolean>(false);

  useEffect(() => {
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    if (value[1] && value[1] < yesterday) {
      setNullEndDate(true);
    } else {
      setNullEndDate(false);
    }
  }, [value[1]]);

  const confirmHandler = () => {
    onConfirm(value[0], value[1]);
    setValue([null, null]);
  };

  return (
    <>
      <Modal show={show} size="lg" centered contentClassName={classes.content}>
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            <FormattedMessage {...messages.title} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.75rem" }}>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-center flex-wrap">
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                locale={enLocale}
              >
                <DateRangePicker
                  startText={<FormattedMessage {...messages.startDate} />}
                  endText={<FormattedMessage {...messages.finishDate} />}
                  value={value}
                  onChange={(newValue: any) => {
                    setValue(newValue);
                  }}
                  renderInput={(startProps, endProps) => (
                    <React.Fragment>
                      <TextField variant="filled" {...startProps} />
                      <Box sx={{ mx: 2 }}></Box>
                      <TextField variant="filled" {...endProps} />
                    </React.Fragment>
                  )}
                />
              </LocalizationProvider>
            </div>
          </div>
          {disablePastEndDate && nullEndDate && (
            <div className={classes.error}>
              <FormattedMessage {...messages.nullEndDate} />
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className={classes.footer}>
          <button
            className={`${classes.btn} ${classes["btn-cancel"]}`}
            onClick={onCloseModal}
          >
            <FormattedMessage {...messages.cancel} />
          </button>
          <button
            disabled={disablePastEndDate && nullEndDate}
            className={`${classes.btn} ${classes["btn-confirm"]}`}
            onClick={confirmHandler}
          >
            <FormattedMessage {...messages.confirm} />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DoubleDateModal;
